import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {IUserCertificateTemplate} from '../shared/model/user-certificate-template.model';

@Injectable({providedIn: 'root'})
export class CertificateTemplateService {
  private url = environment.apiConfig.uri + 'api/vorlagen';

  constructor(private http: HttpClient) {}

  loadTemplates(): Observable<IUserCertificateTemplate[]> {
    return this.http.get<IUserCertificateTemplate[]>(this.url);
  }

  saveTemplate(name: string, certKeys: string[]): Observable<IUserCertificateTemplate> {
    return this.http.post<IUserCertificateTemplate>(this.url, {name, certs: certKeys});
  }

  deleteTemplate(id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }
}
